module.exports =
  accepted: [-180, -90, 0, 90, 180]
  value:    0
